module.exports = __webpack_public_path__ + "img/img_qrcode@2x.886aa192.png";